import { render, staticRenderFns } from "./AgentDossier.vue?vue&type=template&id=1b8a6e35&"
import script from "./AgentDossier.vue?vue&type=script&lang=ts&"
export * from "./AgentDossier.vue?vue&type=script&lang=ts&"
import style0 from "./AgentDossier.vue?vue&type=style&index=0&id=1b8a6e35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports